import { publicApiClient } from '@/lib/api/client';
import type { UserValidationResponse } from '@/features/user/types/types';

/**
 * User validation service for fetching authenticated user data
 */
export const userValidationService = {
  /**
   * Validate user session and get user data
   * @returns Promise<UserValidationResponse> - User data from validation endpoint
   */
  async validateUser(): Promise<UserValidationResponse> {
    try {
      const response = await publicApiClient.get<UserValidationResponse>(
        '/api/public/v1/public-user/validate'
      );
      
      return response;
    } catch (error) {
      console.error('User validation error:', error);
      throw new Error('Failed to validate user. Please try again.');
    }
  }
};
